export default "__VITE_ASSET__BGIKrtvR__"